import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface LifePageProps extends BasePageProps{}

type LifeState = {
    capitale: number | undefined
    anni_polizza: number | undefined
    fumatore: boolean | undefined
    capitaleError?: string
    anniPolizzaError?: string
    fumatoreError?: string
}

export type LifePageState = LifeState & BasePageState

export const lifePageInitialState : LifePageState = {
    ...basePageInitialState,
    ...{
        capitale: undefined,
        anni_polizza: undefined,
        fumatore: undefined,
        capitaleError: undefined,
        anniPolizzaError: undefined,
        fumatoreError: undefined,
    }
}

export const lifeUpdate = createAction<LifePageState>('life/update')

export const lifeReducer = createReducer ( 
    lifePageInitialState,
    (builder) => {
        builder.addCase(lifeUpdate, (state, action) => {
            return action.payload as LifePageState
        })
    }
)

export type LifeRootState = ReturnType<typeof store.getState>
export type LifeDispatch = typeof store.dispatch